<template>
  <div class="d-flex flex-column align-content-between overflow-hidden pb-3 h-100 w-100">
    <admin-tab class="overflow-hidden"/>
    <admin-select-node-modal/>
    <admin-select-relation-type-modal/>
    <admin-table-update-modal/>
    <admin-select-prop-modal/>
  </div>
</template>

<script>
import AdminTab from './AdminTab'
import AdminSelectNodeModal from './AdminSelectNodeModal'
import AdminSelectPropModal from './AdminSelectPropModal'
import AdminSelectRelationTypeModal from './AdminSelectRelationTypeModal'
import AdminTableUpdateModal from './AdminTableUpdateModal'

export default {
  name: 'Admin',
  data () {
    return {
      activeTab: 0,
      links: [
        {
          text: 'AAA'
        }
      ]
    }
  },
  components: {
    AdminTableUpdateModal,
    AdminTab,
    AdminSelectNodeModal,
    AdminSelectPropModal,
    AdminSelectRelationTypeModal
  }
}
</script>

<style lang="sass">
.vld-overlay
  opacity: 0.7
</style>



// WEBPACK FOOTER //
// src/components/Admin.vue